export default "__VITE_ASSET__DbFhBRlI__"